import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';
import { getCurrencyIcon } from '../../../../../../../shared/js/get-currency-icon';

const Currency = ({
	availableCurrencies,
	currentFieldTargets,
	selectedCurrenciesPanIndexMap,
	fieldIndex,
	parentIndex,
	onChangeCurrency
}) => {
	const currencies = [];

	availableCurrencies.forEach(currency => {
		if (!currentFieldTargets) {
			currencies.push(currency);
		} else {
			currentFieldTargets.forEach(entity => {
				if (entity[currency] && currencies.indexOf(currency) === -1) {
					currencies.push(currency);
				}
			});
		}
	});

	return (
		<span className="currency-list">
			{availableCurrencies.map(currency => {
				let currencyForField =
					(selectedCurrenciesPanIndexMap[parentIndex] && selectedCurrenciesPanIndexMap[parentIndex][fieldIndex]) ||
					null;
				let isActive = currencyForField
					? currency === currencyForField
					: currencies.length === 1 ? currency === currencies[0] : currency === 'rub';
				return (
					<span
						key={currency}
						onClick={e => {
							e.stopPropagation();
							onChangeCurrency(parentIndex, fieldIndex, currency);
						}}
						className={cn('currency', isActive && 'active')}
					>
						{getCurrencyIcon(currency)}
					</span>
				);
			})}
		</span>
	);
};

Currency.propTypes = {
	availableCurrencies: PropTypes.array,
	currentFieldTargets: PropTypes.array,
	selectedCurrenciesPanIndexMap: PropTypes.object,
	fieldIndex: PropTypes.number,
	parentIndex: PropTypes.number,
	onChangeCurrency: PropTypes.func
};

export default Currency;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/profile/affiliates/currency.js